import { axiosAiDataInstance } from "@/axios.instance";
import { SummaryData } from "@/store/site-monitor/types";
import { UpdateWorkerCountAction, WorkerCounts } from "@/store/virtual-operator/types";
import { AxiosInstance } from "axios";

class AiDataApi {
    private axios: AxiosInstance;
    private ResponseSaaSPlatformType = 1;

    constructor() {
        this.axios = axiosAiDataInstance;
    }

    public setBaseApiUrl(url: string): void {
        this.axios.defaults.baseURL = url;
    }

    public async generateAiSummary(
        summaryData: SummaryData,
        apiKey: string,
        tenantId: string
    ): Promise<string> {
        const { data } = await this.axios.post(
            `/TextSummary/GenerateResponseSummary`,
            summaryData,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: apiKey,
                    ExternalKey: tenantId,
                    Platform: this.ResponseSaaSPlatformType,
                },
            }
        );

        return data;
    }

    public async getWorkerCounts(apiKey: string, tenantId: string): Promise<WorkerCounts> {
        const { data } = await this.axios.get(`/VirtualOperator/GetWorkerCounts/` + this.ResponseSaaSPlatformType, {
            headers: {
                Authorization: apiKey,
                ExternalKey: tenantId,
                Platform: this.ResponseSaaSPlatformType,
            },
        });

        return data;
    }

    public async updateWorkerCount(action: UpdateWorkerCountAction, apiKey: string, tenantId: string): Promise<void> {
        await this.axios.post(`/VirtualOperator/UpdateWorkerCount`,
            {
                platform: this.ResponseSaaSPlatformType,
                UpdateWorkerCountAction: action
            },
            {
                headers: {
                    Authorization: apiKey,
                    ExternalKey: tenantId,
                    Platform: this.ResponseSaaSPlatformType,
                },
            }
        );
    }
}

const aiDataApi = new AiDataApi();
export default aiDataApi;